import React from 'react';
import { Typography } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	quote: {
		backgroundColor: theme.palette.neutral,
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundImage: 'url(/images/auth.jpg)',
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center'
	},
	quoteInner: {
		textAlign: 'center',
		flexBasis: '600px'
	},
	quoteText: {
		color: theme.palette.white,
		fontWeight: 300
	},
	name: {
		marginTop: theme.spacing(3),
		color: theme.palette.white
	},
	bio: {
		color: theme.palette.white
	}
}));

const LeftQuoteView = props => {
	const classes = useStyles();

	return (
		<div className={classes.quote}>
			<div className={classes.quoteInner}>
				<Typography className={classes.quoteText} variant='h1'>
					Hella narwhal Cosby sweater McSweeney's, salvia kitsch before they
					sold out High Life.
				</Typography>
				<div className={classes.person}>
					<Typography className={classes.name} variant='body1'>
						Takamaru Ayako
					</Typography>
					<Typography className={classes.bio} variant='body2'>
						Manager at inVision
					</Typography>
				</div>
			</div>
		</div>
	);
};

export default LeftQuoteView;
